export const journalists = [
    {
        frames: { width: 187, height: 350, regX: 182 / 2, regY: 350 / 2 },
        animations: {
            stand: {
                frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                next: 'standing',
                speed: 1,
            },
            sit: {
                frames: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
                next: 'sitting',
                speed: 1,
            },
            sitting: {
                frames: [0],
                speed: 0,
            },
            standing: {
                frames: [10],
                speed: 0,
            },
            sad: {
                frames: [20],
                speed: 0,
            },
            happy: {
                frames: [21],
                speed: 0,
            },
        },
        x: 120,
        y: 330,
    },
    {
        frames: { width: 226, height: 365, regX: 226 / 2, regY: 365 / 2 },
        animations: {
            stand: {
                frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                next: 'standing',
                speed: 1,
            },
            sit: {
                frames: [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
                next: 'sitting',
                speed: 1,
            },
            sitting: {
                frames: [0],
                speed: 0,
            },
            standing: {
                frames: [11],
                speed: 0,
            },
            sad: {
                frames: [12],
                speed: 0,
            },
            happy: {
                frames: [13],
                speed: 0,
            },
        },
        x: 240,
        y: 260,
    },
    {
        frames: { width: 186, height: 351, regX: 186 / 2, regY: 351 / 2 },
        animations: {
            stand: {
                frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                next: 'standing',
                speed: 1,
            },
            sit: {
                frames: [10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
                next: 'sitting',
                speed: 1,
            },
            sitting: {
                frames: [0],
                speed: 0,
            },
            standing: {
                frames: [10],
                speed: 0,
            },
            sad: {
                frames: [16],
                speed: 0,
            },
            happy: {
                frames: [17],
                speed: 0,
            },
        },
        x: 355,
        y: 330,
    },
    {
        frames: { width: 227, height: 365, regX: 227 / 2, regY: 365 / 2 },
        animations: {
            stand: {
                frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                next: 'standing',
                speed: 1,
            },
            sit: {
                frames: [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
                next: 'sitting',
                speed: 1,
            },
            sitting: {
                frames: [0],
                speed: 0,
            },
            standing: {
                frames: [11],
                speed: 0,
            },
            sad: {
                frames: [12],
                speed: 0,
            },
            happy: {
                frames: [13],
                speed: 0,
            },
        },
        scale: 1,
        x: 470,
        y: 260,
    },
    {
        frames: { width: 244, height: 394, regX: 244 / 2, regY: 394 / 2 },
        animations: {
            stand: {
                frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                next: 'standing',
                speed: 1,
            },
            sit: {
                frames: [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
                next: 'sitting',
                speed: 1,
            },
            sitting: {
                frames: [0],
                speed: 0,
            },
            standing: {
                frames: [11],
                speed: 0,
            },
            sad: {
                frames: [12],
                speed: 0,
            },
            happy: {
                frames: [13],
                speed: 0,
            },
        },
        x: 580,
        y: 330,
    },
    {
        frames: { width: 191, height: 359, regX: 191 / 2, regY: 359 / 2 },
        animations: {
            stand: {
                frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                next: 'standing',
                speed: 1,
            },
            sit: {
                frames: [10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
                next: 'sitting',
                speed: 1,
            },
            sitting: {
                frames: [0],
                speed: 0,
            },
            standing: {
                frames: [10],
                speed: 0,
            },
            sad: {
                frames: [21],
                speed: 0,
            },
            happy: {
                frames: [22],
                speed: 0,
            },
        },
        x: 710,
        y: 260,
    },
    {
        frames: { width: 232, height: 373, regX: 232 / 2, regY: 373 / 2 },
        animations: {
            stand: {
                frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                next: 'standing',
                speed: 1,
            },
            sit: {
                frames: [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
                next: 'sitting',
                speed: 1,
            },
            sitting: {
                frames: [0],
                speed: 0,
            },
            standing: {
                frames: [11],
                speed: 0,
            },
            sad: {
                frames: [12],
                speed: 0,
            },
            happy: {
                frames: [13],
                speed: 0,
            },
        },
        x: 835,
        y: 330,
    },
    {
        frames: { width: 207, height: 355, regX: 207 / 2, regY: 355 / 2 },
        animations: {
            stand: {
                frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                next: 'standing',
                speed: 1,
            },
            sit: {
                frames: [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
                next: 'sitting',
                speed: 1,
            },
            sitting: {
                frames: [0],
                speed: 0,
            },
            standing: {
                frames: [11],
                speed: 0,
            },
            sad: {
                frames: [12],
                speed: 0,
            },
            happy: {
                frames: [13],
                speed: 0,
            },
        },
        x: 940,
        y: 260,
    },
    {
        frames: { width: 203, height: 379, regX: 203 / 2, regY: 379 / 2 },
        animations: {
            stand: {
                frames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                next: 'standing',
                speed: 1,
            },
            sit: {
                frames: [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
                next: 'sitting',
                speed: 1,
            },
            sitting: {
                frames: [0],
                speed: 0,
            },
            standing: {
                frames: [11],
                speed: 0,
            },
            sad: {
                frames: [22],
                speed: 0,
            },
            happy: {
                frames: [23],
                speed: 0,
            },
        },
        scale: 1,
        x: 1050,
        y: 330,
    },
];
